// @generated by protoc-gen-connect-es v1.6.1
// @generated from file ai/h2o/mlops/deployer/v1/deployment_profiling_service.proto (package ai.h2o.deploy, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { GetSuggestedScoringResourceSpecRequest, GetSuggestedScoringResourceSpecResponse, ListSuggestedScoringCompositionsRequest, ListSuggestedScoringCompositionsResponse } from "@buf/h2oai_mlops-deployment.bufbuild_es/ai/h2o/mlops/deployer/v1/deployment_profiling_service_pb.js";
import { MethodKind } from "@bufbuild/protobuf";

/**
 * The Scorer Profiling Service.
 *
 * @generated from service ai.h2o.deploy.DeploymentProfilingService
 */
export const DeploymentProfilingService = {
  typeName: "ai.h2o.deploy.DeploymentProfilingService",
  methods: {
    /**
     * List scoring compositions support profiling for given artifact.
     *
     * @generated from rpc ai.h2o.deploy.DeploymentProfilingService.ListSuggestedScoringCompositions
     */
    listSuggestedScoringCompositions: {
      name: "ListSuggestedScoringCompositions",
      I: ListSuggestedScoringCompositionsRequest,
      O: ListSuggestedScoringCompositionsResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Get suggested resource spec for given composition.
     *
     * @generated from rpc ai.h2o.deploy.DeploymentProfilingService.GetSuggestedScoringResourceSpec
     */
    getSuggestedScoringResourceSpec: {
      name: "GetSuggestedScoringResourceSpec",
      I: GetSuggestedScoringResourceSpecRequest,
      O: GetSuggestedScoringResourceSpecResponse,
      kind: MethodKind.Unary,
    },
  }
};

